import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { StripeCreateCustomerBillingResponse } from "@/common/types/stripe";
import { usePostStripe } from "@/hooks/stripe/usePostStripe";
import { useEffect } from "react";
import { createCustomerBillingSession } from "@/services/stripe";
import { t } from "i18next";
import type { UserData } from "@/services/auth";

interface ManageSubscriptionProps {
  userData: UserData;
}

export default function ManageSubscription(
  props: ManageSubscriptionProps
): JSX.Element {
  const { data, isLoading, triggerFetch } =
    usePostStripe<StripeCreateCustomerBillingResponse>();

  function initialData(): void {
    triggerFetch(() =>
      createCustomerBillingSession({
        customerId: props.userData.stripeCustomerId,
      })
    );
  }

  const handleClickManage = (): void => {
    if (data) {
      window.open(data?.url);
    }
  };

  useEffect(() => {
    initialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-y-6">
      <p>{t("settings.subscription.manageSubscription.description")}</p>
      <Button disabled={isLoading} onClick={handleClickManage}>
        {isLoading && <Loader2 className="animate-spin" />}
        {t("settings.subscription.manageSubscription.manageButton")}
      </Button>
    </div>
  );
}
